import { imageUrl, PLACEHOLDER_IMAGE } from './urlService';

const WISHLIST_KEY = 'shopping_wishlist';

export const getWishlistItems = () => {
  const data = localStorage.getItem(WISHLIST_KEY);
  const items = data ? JSON.parse(data) : [];
  return items.map(item => ({ ...item, image: item.image || PLACEHOLDER_IMAGE }));
};

export const addToWishlist = (product) => {
  let items = getWishlistItems();
  const exists = items.some(item => item.id === product.id);
  if (!exists) {
    items.push({
      id: product.id,
      name: product.name,
      slug: product.slug,
      image: imageUrl(product.image) || product.image || PLACEHOLDER_IMAGE,
      price: product.price,
      mrp: product.mrp,
      category: product.category,
      addedAt: new Date().toISOString(),
    });
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { count: items.length } }));
  }
  return items;
};

export const removeFromWishlist = (productId) => {
  let items = getWishlistItems();
  items = items.filter(item => item.id !== productId);
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { count: items.length } }));
  return items;
};

export const isInWishlist = (productId) => {
  const items = getWishlistItems();
  return items.some(item => item.id === productId);
};

export const getWishlistCount = () => {
  return getWishlistItems().length;
};

export const clearWishlist = () => {
  localStorage.removeItem(WISHLIST_KEY);
  window.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { count: 0 } }));
};
